<template>
    <div class="bg-grey">
      <CCol sm="12" class="text-center" style="width: 96%;background-size: cover; margin: auto;">
        <CRow class="m-0 justify-content-center align-items-center">
          <br /><br /><br />
          <div class="header-top mt-3">
            <img width="25px" height="25px" src="../assets/img/gear.png" class="float-right mb-3" style="position: relative;" @click="GoToSetting" />
            <br /><br />
            
  
            <CRow>
              <div style="width:20%"> 
                <span class="custom-header-profile">
                  <img width="50px" height="50px" src="../assets/img/iconuser1.png" style="position: relative; z-index: 2;" />
                </span>
              </div>
              
              <div style="width:80%">
                <div style="text-align: left; position: relative;">
                  <span>
                    <h1 class="custom-12px m-0 float-left mt-3" style="position: relative; z-index: 1; font-size: 16px;"> Nasrul </h1>
                    <h1 class="m-0 float-right custom-blue-10px-500" style="position: relative; z-index: 1;">
                      <CButton class="bg-light-blue"> Genie Workers </CButton>   
                    </h1>
                    <br /><br />
                    <div style="width:100%; position: relative;">
                      <img style="max-width: 90%; position: relative; z-index: 1;" class="float-left" src="../assets/img/Progress.png" />
                      <img style="max-width: 20px; position: relative; z-index: 1;margin-top:-5px" src="../assets/img/mahkota.png" class="float-right" />
                    </div>
                    <CRow>
                      <div style="width:60%"> 
                        <CButton class="bg-white b-20 mt-2"> Redeem </CButton>
                      </div>
                      <div style="width:40%">
                        <label class="mt-3" >1950/2000 pts </label>
                      </div>
                    </CRow>
                  </span>
                </div>
              </div>
            </CRow>
          </div>
        </CRow>
        <div style="clear:both"></div>
  <br /><br />
        
  
        <CRow class="mt-5 m-1">
          <CCol sm="12" class="m-0 p-0">
            <h3 class="custom-16px-500 text-left"> Available </h3>
          </CCol>
          <div style="width:33%">
            <CCard class="b-12px mr-2" @click="GoToRequest()">
              <img style="width:50px" src="../assets/img/request.png" class="m-2" />
              <CCol sm="12">
                <h1 class="custom-12px-profile text-left"> Requested </h1>
                <h5 class="custom-24px-profile text-left"> 24 </h5>
              </CCol>
            </CCard>
          </div>
          <div style="width:33%">
            <CCard class="b-12px mr-2">
              <img style="width:50px" src="../assets/img/award.png" class="m-2" />
              <CCol sm="12">
                <h1 class="custom-12px-profile text-left"> Award </h1>
                <h5 class="custom-24px-profile text-left"> 24 </h5>
              </CCol>
            </CCard>
          </div>
          <div style="width:33%">
            <CCard class="b-12px">
              <img style="width:50px" src="../assets/img/job.png" class="m-2" />
              <CCol sm="12">
                <h1 class="custom-12px-profile text-left"> Job </h1>
                <h5 class="custom-24px-profile text-left"> 24 </h5>
              </CCol>
            </CCard>
          </div>
        </CRow>
  
        <CRow class="p-0">
          <CCol sm="12" style="background-size: cover; color: #fff;border-radius:20px" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <div style="width:80%" class="p-2 text-left">
              <h3 class="custom-reward text-left mt-3 ml-2"> Redeem Rewards </h3>
              <label class="text-white custom-12px text-left ml-2">
                Claim Reward Points and <br />
                enjoy more discount with <br />
                Pickiddo
              </label>
              <br /><br /> 
              <CButton class="bg-white b-20 mt-2 ml-2"> Redeem </CButton>
              <br /><br /> 
            </div>
          </CCol>
        </CRow>
        <br /><br /><br />
      </CCol>
      <MainlayoutBottom></MainlayoutBottom>
      
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  
  import backgroundUrl from "../assets/img/bgHomeUser.png";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
              backgroundUrl
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
          GoToLogin() {
              // Close the popup and backdrop
              this.$router.push("/RegisterHomepage");
          },
  
          GoToRequest()
          {
              this.$router.push("/Request");
          },
  
          GoToTopup()
          {
              this.$router.push("/TopupToken");
          },
  
          GoToSetting()
          {
              this.$router.push("/Setting");
          }
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>